/**
 * Created by Qingger Corp.
 * User: 陈儒
 * Date: 2019/12/10
 * Time: 14:22
 * Desc:
 */
import { Component, Vue } from 'vue-property-decorator';
import NoAuth from '@/views/components/noAuth/noAuth.vue';

// 子组件
import DistributeBoardHistory from '@/views/components/distributeBoardHistory/distributeBoardHistory.vue'; // 分销历史
import WithdrawBoardHistory from '@/views/components/withdrawBoardHistory/withdrawBoardHistory.vue'; // 提现历史

@Component({
  components: {
    DistributeBoardHistory,
    WithdrawBoardHistory,
    NoAuth,
  },
})
export default class distributeBoardInfo extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  public vGuiderSource = 0;

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /* 方法 */

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
  }
  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-DISTRIBUTE-VIRGUIDER');
    if (+this.$route.query.index === 2) {
      this.curPage = '2';
    }
  }
}
